<div id="QRCode" class="ya-typography" (swiperight)="SwiperNavigateBack()">
  <ya-subheader [hasContent]="true" [disableNavigateBack]="true" (onNavigateBackClick)="handleNavigateBack()">
    <ng-container *ngIf="hasAccess">
      <ng-container *ngIf="isMobile">
        <div class="flashlight-button qrcode-backgournd ya-page-content--webshop">
          <ng-container *ngIf="!flashEnabled; then flashOnTemplate else flashOffTemplate"></ng-container>
          <ng-template #flashOnTemplate>
            <button mat-mini-fab (click)="turnOnFlashLight()">
              <div class="inline-icon" inlineSVG="shop-icons.svg#ya-torch-on"></div>
            </button>
          </ng-template>
          <ng-template #flashOffTemplate>
            <button mat-mini-fab (click)="turnOffFlashLight()">
              <div class="inline-icon" inlineSVG="shop-icons.svg#ya-torch-off"></div>
            </button>
          </ng-template>
        </div>
      </ng-container>
    </ng-container>
  </ya-subheader>
  <div class="ya-page-content ya-page-content--inset">
    <ng-container *ngIf="isGroupOrder">
      <div class="inline-icon groupOrder_join_icon" inlineSVG="shop-icons.svg#ya-hypersoft-gruppe-beitreten"></div>
    </ng-container>
    <ng-container *ngIf="!isGroupOrder">
      <div class="inline-icon groupOrder_join_icon" inlineSVG="shop-icons.svg#ya-hypersoft-tisch"></div>
    </ng-container>
    <div class="qrcode-description qrcode-backgournd ya-page-content--webshop">
      <h2 [langkey]="!isGroupOrder? 'phQRCode_Page_Title':'phGroupOrder_QRCode_Scanner_Title' "></h2>
      <p [langkey]="!isGroupOrder?'phQRCode_page_Description':'phGroupOrder_QRCode_Scanner_SubText'"></p>
    </div>
    <div class="qrcode-frame-container">
      <div class="qrcode-side-frame qrcode-backgournd ya-page-content--webshop"></div>
      <div class="qrcode-frame">
        <div class="aspect-equal-ratio-box">
          <div class="aspect-ratio-box-inside">
            <ng-container *ngIf="hasAccess; then cameraAccessTemplate else cameraNotAccessTemplate"></ng-container>
            <ng-template #cameraAccessTemplate>
              <div class="camera-frame" id="camera-frame">
                <zxing-scanner *ngIf=" !isMobile && zXingScanner" [formats]="['QR_CODE']"
                  (camerasNotFound)="onCamerasnotfound($event)" (camerasFound)="onCamerasFound($event)"
                  (scanError)="scanErrorHandler($event)" (permissionResponse)="onPermissionResponse($event)"
                  (scanFailure)="scanFailureHandler($event)" (scanComplete)="scanCompleteHandler($event)">
                </zxing-scanner>
              </div>
            </ng-template>
            <ng-template #cameraNotAccessTemplate>
              <div class="camera-Container ya-page-content--webshop">
                <div class="inline-icon" inlineSVG="shop-icons.svg#ya-no_camera"></div>
                <p langkey="phQRCode_Access_Denied_Text"></p>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="qrcode-side-frame qrcode-backgournd ya-page-content--webshop"></div>
    </div>
  </div>
  <div class="qrcode-manual-input qrcode-backgournd ya-page-content--webshop">
    <div class="camera-noaccess-text">
      <p [innerHTML]="isGroupOrder? groupOrderNoCameraHTML: noCameraHTML"></p>
    </div>
    <ng-container *ngIf="!isGroupOrder">
      <div class="ya-button-container">
        <button a11y_Button mat-flat-button (click)="routeToManualQRCode()">
          <span langkey="phQRCode_Page_Button"></span>
        </button>
      </div>
    </ng-container>
  </div>
</div>